import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about">
      <h2>About Us</h2>
      <p>Handibhog Restaurant is a highway dining destination coming up on Dhampurâ€“Nagina Road (NH-734), District Bijnor, Uttar Pradesh, crafted to serve travellers, families, and food lovers with comfort, quality, and authentic taste.

Founded in 2026, Handibhog Restaurant is built with a simple vision â€” to offer fresh, hygienic, and flavour-rich food in a welcoming space where guests can relax, refuel, and enjoy a satisfying meal during their journey. Whether youâ€™re on a long drive, a family trip, or a daily commute, Handibhog aims to be your trusted stop for good food and great service.

We focus on quality ingredients, consistent taste, and cleanliness, ensuring every dish meets the expectations of both highway travellers and local guests. Our menu is thoughtfully designed to cater to a wide range of preferences, offering comforting Indian flavours that feel familiar yet fulfilling.

At Handibhog Restaurant, taste is our promise and safety is our priority. With warm hospitality and a convenient highway location, we look forward to becoming a place you stop by once â€” and return to every time you pass by.</p>
      <div className="owner-info">
        <h3>Owner: Mr. Prateek Singh & Ms. Mamta</h3>
        <p>With years of experience in the culinary arts, Mr. Prateek Singh brings the essence of North Indian cuisine to your table.</p>
      </div>
    </section>
  );
}

export default About;
